<div class="overlay-hard complete">{{ 'GenerationInProgress' | translate }}</div>
<ng-container>
  <div class="page title-page">
    <img id="print-logo" src="assets/images/logo_big.png" alt="logo" />
    <h1>{{ 'ActivityReport' | translate }}</h1>
    <h3>{{ 'FromTo' | translate: { from: startDate, to: endDate } }}</h3>
    <h4 id="generated-by">{{ 'GeneratedBy' | translate: { userName: userName, date: today } }}</h4>
    <h4>{{ this.auth.currentOrganization.name }}</h4>
    <h4>Cluster : {{ cluster?.name }}</h4>

    @if (tags && tags.length > 0 && tags[0] !== null) {
      <div>
        <h4>Tag : {{ tags }}</h4>
      </div>
    }

    <ng-container *ngIf="siteNames?.length">
      <h4>Sites ({{ siteNames.length }}) :</h4>
      <p *ngFor="let host of siteNames" class="print-host">{{ host }}</p>
    </ng-container>
    <ng-container *ngIf="!siteNames?.length">
      <h4>{{ 'Organization' | translate }} {{ auth.currentOrganization.name }}</h4>
    </ng-container>
  </div>

  <div class="page">
    <h2>{{ 'TableOfContents' | translate }}</h2>
    <ul class="toc">
      <li>
        <span class="title">{{ 'RequestsAndBreakdowns' | translate }}</span>
        <span class="chapter">3</span>
      </li>
      <li>
        <span class="title">{{ 'GeoOriginsOf' | translate }}&nbsp;</span>
      </li>
      <li>
        <span class="title subtitle">{{ 'requests' | translate }}</span>
        <span class="chapter">4</span>
      </li>
      <li>
        <span class="title subtitle">{{ 'robotRequests' | translate }}</span>
        <span class="chapter">5</span>
      </li>
      <li>
        <span class="title subtitle">{{ 'attackRequests' | translate }}</span>
        <span class="chapter">6</span>
      </li>
      <li>
        <span class="title">{{ 'FrequentsAndSlowsRequests' | translate }}</span>
        <span class="chapter">7-8</span>
      </li>
      <li>
        <span class="title">{{ 'Glossary' | translate }}</span>
        <span class="chapter">9</span>
      </li>
    </ul>
  </div>
  <div class="page">
    <h2>{{ 'RequestsAndBreakdowns' | translate }}</h2>

    <div class="metrics">
      <p>{{ 'RequetesAnalysees' | translate }} : {{ totals.analyzed | numberFormat }}</p>
      <p>{{ 'Bloquees' | translate }} : {{ totals.blocked | numberFormat }}</p>
      <p>{{ 'Suspectes' | translate }} : {{ totals.suspect | numberFormat }}</p>
      <p>{{ 'Robots' | translate }} : {{ totals.robot | numberFormat }}</p>
    </div>

    <app-donut
      *ngIf="!isLoading && blockAttack"
      [print]="true"
      [data]="blockAttack"
      [fontSize]="'30px'"
      [title]="'TypesAttaques' | translate"
    />

    <app-graph [data]="audience" [fontSize]="'30px'" height="600px" />
  </div>

  @for (graphType of COUNTRY_GRAPH_TYPES; track graphType) {
    <div class="page">
      <div class="title-map">
        <h3>{{ 'Origins.title.' + graphType | translate }}</h3>
        <p>{{ 'Origins.description.' + graphType | translate }}</p>
      </div>
      <div class="world-map">
        <app-world-map
          [showTopCountryNames]="false"
          [data]="countryDatas?.[graphType]"
          [colorStops]="MAP_COLOR_STOPS[graphType]"
        />
      </div>
    </div>
  }

  <div class="page">
    <h2>{{ 'topBlockedIps' | translate }}&nbsp;{{ periodMoreThan7Days ? ('7LastDays' | translate) : '' }}</h2>
    <app-blocked-ips-table [print]="true" [topBlockedIps]="topBlockedIps" />
  </div>

  <div class="page">
    <h2>
      {{ 'FrequentsAndSlowsRequests' | translate }}&nbsp;{{ periodMoreThan7Days ? ('7LastDays' | translate) : '' }}
    </h2>
    <h4>{{ 'RequetesLentes' | translate }}</h4>
    <app-slow-requests-table [slowRequests]="slowRequests" [print]="true" />

    <h4 class="page-break">{{ 'PagesPlusVisitees' | translate }}</h4>
    <app-most-frequent-requests-table [cpuConsumingRequests]="cpuConsumingRequests" [print]="true" />
  </div>

  <div class="page">
    <h2>{{ 'Glossary' | translate }}</h2>

    <h4>{{ 'XSSInjection' | translate }}</h4>
    <p><b> Description : </b> {{ 'XSSInjectionDescription' | translate }}</p>
    <p><b> Impact : </b> {{ 'XSSInjectionImpact' | translate }}</p>

    <h4>{{ 'SQLInjection' | translate }}</h4>
    <p><b> Description : </b> {{ 'SQLInjectionDescription' | translate }}</p>
    <p><b> Impact : </b> {{ 'SQLInjectionImpact' | translate }}</p>

    <h4>{{ 'Bruteforce' | translate }}</h4>
    <p><b> Description : </b> {{ 'BruteforceDescription' | translate }}</p>
    <p><b> Impact : </b> {{ 'BruteforceImpact' | translate }}</p>

    <h4>{{ 'DOS' | translate }}</h4>
    <p><b> Description : </b> {{ 'DOSDescription' | translate }}</p>
    <p><b> Impact : </b> {{ 'DOSImpact' | translate }}</p>
  </div>
</ng-container>
